import { useEffect, useLayoutEffect, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useLeftBar } from "../../context/LeftBar";

import NavItem from "./MenuItem/NavItem";
import utils from "../../Utils";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const screenBreakpoint = 500;

  const changeLanguage = async (tempApp, language) => {
    localStorage.setItem("language", language);
    i18n.changeLanguage(language);
    // await tempApp.field(config.app.langVar).selectMatch(utils.languageHandleQVF(language));
  };

  useLayoutEffect(() => {
    let language = params.get("lang");
    if (!language) {
      language = localStorage.getItem("language");
    }
    language = utils.guardLanguage(language);
    changeLanguage(app, language);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();
  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="leftSideHeader">
        <div className={leftBarOpened ? "logo" : "logo is-hidden"}>
          <img src={logo} alt="logo" />
        </div>
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          <i
            className={
              leftBarOpened
                ? "fal fa-arrow-left close-desktop"
                : "fal fa-arrow-right"
            }
          />
          <i className={leftBarOpened ? "fal fa-times close-mobile" : ""} />
        </button>
      </div>
      <div className="leftSideContent">
        <div>&nbsp;</div>
        <ul>
          <NavItem
            icon="fas fa-table"
            name={t("menu")[0].title}
            path="/strategic-analysis"
          />
          <NavItem
            icon="fas fa-calculator"
            name={t("menu")[1].title}
            path="/tatical-analysis"
          />
          <NavItem
            icon={
              screenWidth < screenBreakpoint
                ? "fas fa-chart-line"
                : "fas fa-chart-line"
            }
            name={t("menu")[2].title}
            path="/behaviour-analysis"
            subpages={[
              {
                id: 1,
                url: "/behaviour-analysis/basket-mix",
                name: t("menu")[2].children[0].title,
              },
            ]}
          />
          <NavItem
            icon="fas fa-chart-bar"
            name="Self-Service"
            path="/self-service"
          />
          {/* <NavItem
                        icon={screenWidth < screenBreakpoint ? 'fas fa-cog-alt' : 'fas fa-cog'}
                        name="Configurações"
                        path="/configuracoes"
                        subpages={[
                            { id: 1, url: '/configuracoes/tpr', name: 'Alteração de Preços' }]}
                    /> */}
        </ul>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  logo: "",
  config: {},
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  logo: PropTypes.string,
  config: PropTypes.object,
};

export default LeftSideMenu;
